import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps, useTheme } from '@mui/material';

export interface TooltipProps extends Omit<MuiTooltipProps, 'placement'> {
  /**
   * The id of the entry
   */
  id: string;

  /**
   * The width of popup
   * @default 300
   */
  width?: string | number | 'auto';

  /**
   * The position of the tooltip
   * @default right
   */
  placement?: MuiTooltipProps['placement'];
}

export function Tooltip(props: TooltipProps) {
  const { id, width = 300, children, placement = 'right', sx, ...rest } = props;
  const theme = useTheme();

  return (
    <MuiTooltip
      data-testid={`${id}-tooltip`}
      slotProps={{
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': {
              maxWidth: 'none', // Remove the default max-width
              width: width,
              padding: '8px 16px',
              ...theme.typography.body2,
              letterSpacing: '0.15px',
              color: theme.palette.white.main,
            },
            '& :focus': {
              outline: 'none !important',
              boxShadow: 'none !important',
            },
            ...sx,
          },
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -8],
              },
            },
          ],
        },
      }}
      placement={placement}
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
}
